// -----  Constants  ---------------------------------------------------------
const CLASSES = {
    inited:    'js-inited',
    visible:  'visible',
    filterWrapper:   'po-filter-title__wrapper',
    selectedText: 'po-filter-title__selected-text',
    dropdown:  'po-filter-dropdown',
    closeBtn: 'po-filter-dropdown__close',
    assetsList:  'assets-list'
};

const TEXT_NO_DATA = window.poSettings?.i18n?.noData ?? 'No data available';
const FALLBACK_ICON = window.poSettings?.defaultIconUrl ?? '/wp-content/themes/pocket-option-blog/asset-icons/_Default/stocks-def.webp';

/**
 * Universal WP REST API base, auto-detects /blog, /en etc.
 */
function getWpRestBaseUrl() {
    const match = location.pathname.match(/^((\/[a-z0-9-_]+)*)(?=\/wp-json|\/$|$)/i);
    return match ? match[1] : '';
}

/**
 * Получить endpoint для assets
 */
function getAssetsApiUrl() {
    return `${getWpRestBaseUrl()}/wp-json/po/v1/assets`;
}

/**
 * Initialise the Top‑Assets UI.
 */
const initTopAssets = () => {
    document.querySelectorAll(`.${CLASSES.filterWrapper}`).forEach(filterWrapper => {
        if (filterWrapper.classList.contains(CLASSES.inited)) return;
        filterWrapper.classList.add(CLASSES.inited);

        const selectedText = filterWrapper.querySelector(`.${CLASSES.selectedText}`);
        const dropdown     = filterWrapper.querySelector(`.${CLASSES.dropdown}`);
        const closeBtn    = dropdown?.querySelector(`.${CLASSES.closeBtn}`);
        const list = document.getElementById(CLASSES.assetsList);

        if (!dropdown || !selectedText || !list) {
            console.error('[TopAssets] Required elements not found');
            return;
        }

        // -------------- Dropdown ----------------
        const toggleDropdown = (show = null) => {
            const shouldShow = (show !== null) ? !!show : !dropdown.classList.contains(CLASSES.visible);
            dropdown.classList.toggle(CLASSES.visible, shouldShow);
            dropdown.setAttribute('aria-hidden', !shouldShow);
            filterWrapper.setAttribute('aria-expanded', shouldShow);
        };

        const handleWrapperClick = e => {
            if (
                e.target.classList.contains(CLASSES.selectedText) ||
                e.target.classList.contains('po-filter-title__corner-icon') ||
                e.target === filterWrapper
            ) {
                e.stopPropagation();
                toggleDropdown();
            }
        };

        const handleItemClick = async e => {
            e.stopPropagation();
            const item = e.target.closest('div');
            if (!item) return;

            const category = item.dataset.category;
            selectedText.textContent = item.textContent;
            toggleDropdown(false);

            try {
                const resp = await fetch(`${getAssetsApiUrl()}?type=${encodeURIComponent(category)}`);
                const data = await resp.json();

                if (!data.success || !Array.isArray(data.assets)) {
                    throw new Error('Invalid response');
                }

                renderAssetsList(list, data.assets, category);
            } catch (err) {
                console.error('[TopAssets] fetch error', err);
                renderAssetsList(list, [], category);
            }
        };

        const handleDocumentClick = e => {
            if (!filterWrapper.contains(e.target)) {
                toggleDropdown(false);
            }
        };

        filterWrapper.addEventListener('click', handleWrapperClick);

        if (closeBtn) {
            closeBtn.addEventListener('click', e => {
                e.stopPropagation();
                toggleDropdown(false);
            });
        }

        dropdown.querySelectorAll('div').forEach(item => {
            item.addEventListener('click', handleItemClick);
        });

        document.addEventListener('click', handleDocumentClick);
    });
};

/**
 * Render the assets list.
 */
function renderAssetsList(container, assets = [], category = '') {
    if (container.replaceChildren) {
        container.replaceChildren();
    } else {
        while (container.firstChild) {
            container.removeChild(container.firstChild);
        }
    }

    container.appendChild(
        createAssetRow(
            window.poSettings?.i18n?.assetName ?? 'Asset Name',
            window.poSettings?.i18n?.payout ?? 'Payout',
            true
        )
    );

    if (!assets.length) {
        const empty = document.createElement('div');
        empty.className = 'top-assets__row';
        empty.innerHTML = `
            <div class="top-assets__cell">${TEXT_NO_DATA}</div>
        `;
        container.appendChild(empty);
        return;
    }

    assets.forEach(asset => {
        const isActive = asset.is_active === 1 || asset.is_active === '1';
        const label    = escapeHTML(asset.label ?? '');
        const iconUrl = asset.icon_url ?? FALLBACK_ICON;
        const type    = escapeHTML((asset.type ?? category ?? '').toUpperCase());

        const row = document.createElement('div');
        row.className = 'top-assets__row';
        row.innerHTML = `
            <div class="top-assets__cell top-assets__cell--left">
                <img 
                    class="top-assets__logo"
                    src="${iconUrl}"
                    alt="${label} icon"
                    width="32" height="32"
                    loading="lazy"
                    onerror="this.onerror=null;this.src='${FALLBACK_ICON}';"
                >
                <span class="top-assets__name">${label}</span>
                <small class="top-assets__label">${type}</small>
            </div>
            <div class="top-assets__cell top-assets__cell--right">
                <span class="top-assets__payout">${asset.payout}%</span>
                ${isActive ? '<span class="top-assets__status-dot"></span>' : ''}
            </div>
        `;
        container.appendChild(row);
    });
}

function escapeHTML(str) {
    const el = document.createElement('div');
    el.textContent = str;
    return el.innerHTML;
}

function createAssetRow(nameText, payoutText, isHeader = false) {
    const row = document.createElement('div');
    row.className = `top-assets__row ${isHeader ? 'top-assets__row--head' : ''}`;
    row.innerHTML = `
        <div class="top-assets__cell">${escapeHTML(nameText)}</div>
        <div class="top-assets__cell">${escapeHTML(payoutText)}</div>
    `;
    return row;
}

export { initTopAssets };
